module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "OT"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Stewart_Envisioning_the_Congregation_text_CC4#_idTOCAnchor-2"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Stewart_Envisioning_the_Congregation_text_CC5#_idTOCAnchor-3"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Stewart_Envisioning_the_Congregation_text_CC6#_idTOCAnchor-4"
    }
  }, [_vm._v("1. Reimagining the Future of Protestant Congregations")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Stewart_Envisioning_the_Congregation_text_CC7#_idTOCAnchor-5"
    }
  }, [_vm._v("2. Cultural Impulses in American Congregations")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Stewart_Envisioning_the_Congregation_text_CC8#_idTOCAnchor-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. The Gospel in Four Dimensions")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Stewart_Envisioning_the_Congregation_text_CC9#_idTOCAnchor-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. On Practices")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Stewart_Envisioning_the_Congregation_text_CC10#_idTOCAnchor-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Practicing the Arts of Belonging: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Koinonia ")])])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Stewart_Envisioning_the_Congregation_text_CC11#_idTOCAnchor-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Practicing the Arts of Discipleship: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mathētēs")])])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Stewart_Envisioning_the_Congregation_text_CC12#_idTOCAnchor-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Practicing the Arts of Witnessing: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Martyria")])])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Stewart_Envisioning_the_Congregation_text_CC13#_idTOCAnchor-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Practicing the Arts of Serving: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Diakonia")])])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Stewart_Envisioning_the_Congregation_text_CC14#_idTOCAnchor-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Practicing the Arts of Worship: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Leitourgia")]), _c('br'), _c('span', {
    staticClass: "semiboldsc"
  }, [_vm._v("Part One")]), _vm._v(" — Word, Sacraments, Prayer")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1",
    attrs: {
      "id": "toc12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Stewart_Envisioning_the_Congregation_text_CC15#_idTOCAnchor-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Practicing the Arts of Worship: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Leitourgia")]), _c('br'), _c('span', {
    staticClass: "semiboldsc"
  }, [_vm._v("Part Two")]), _vm._v(" — Community, Family, Personal")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Stewart_Envisioning_the_Congregation_text_CC16#_idTOCAnchor-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Stewart_Envisioning_the_Congregation_text_CC17#_idTOCAnchor-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Works Cited")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2",
    attrs: {
      "id": "toc15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Stewart_Envisioning_the_Congregation_text_CC18#_idTOCAnchor-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a137b8d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Stewart_Envisioning_the_Congregation_text_CC3.vue
// module id = 63
// module chunks = 0